import {Button, IconButton} from '@material-ui/core';
import {Close} from '@material-ui/icons';
import React from 'react';
import Modal from './Modal';
import './IntroModal.scss';

const IntroModal = ({onClose}) => {
    return (
        <Modal className="intro-modal">
            <IconButton aria-label="close" onClick={onClose} className="close-btn">
                <Close />
            </IconButton>

            <h1>Hey there!</h1>
            <div className="content">
                <p>
                    My name is <b>Matti Bar-Zeev</b> and this is a Words Search Game I made with React, Redux and some
                    other cool stuff.<br></br>This game originated as my sandbox for all sorts of React experiments and
                    learning, but I think it reached a point where people might actually enjoy* and learn from it too :)
                </p>

                <h4>How do I play?</h4>
                <p>
                    Click-and-drag the letters and you will see that the letters you hover on are getting collected.
                    Releasing the mouse will allow you to pick the matching word from the words bank on the left. Got
                    the word right? it's a score!
                </p>
                <h4>Editing</h4>
                <p>You can edit the game by adding or removing words from the words bank. Try it out!</p>
                <h4>Feedback</h4>
                <p>
                    I would love read your thoughts, questions, issues, typos and whatever you feel like sharing with
                    me. You can contact me on Twitter{' '}
                    <a href="https://twitter.com/mattibarzeev" target="_blank" rel="noopener noreferrer">
                        @mattibarzeev
                    </a>{' '}
                    <br></br>
                    <br></br>
                    Cheers!
                </p>

                <p>
                    <small>
                        <i>* Sadly this game is not supported on touch devices... yet ;)</i>
                    </small>
                </p>
            </div>

            <Button variant="contained" color="primary" onClick={onClose}>
                Let's play!
            </Button>
        </Modal>
    );
};

export default IntroModal;
